import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


const __default__ = {
    name: "PopoverMenuItem"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    disabled: { type: Boolean },
    bold: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass({
            'text-truncate': true,
            disabled: __props.disabled,
            'font-weight-bold': __props.bold
        }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('click')))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})